import { environment } from "src/environments/environment";
export default {
  oidc: {
    clientId: environment.clientId,
    issuer: environment.issuer,
    redirectUri: environment.redirectUri,
    scopes: ["openid", "profile", "email"],
  },
};
